import type { PhotoId } from './valueObjects/photoId';
import type { PhotoAppJson } from '@/types/domain/photo/entities/photoAppEntity';

import { EntityPvt } from '@/domain/entityPvt';
import { EntityName } from '@/infra/appsync';
import { EntityNamePvt } from '@/types/common/entityPvt';

/**
 * 写真のダウンロード期限月数
 */
export const PHOTO_EXPIRED_MONTH = 2;
/**
 * 写真のダウンロード期限月数 改訂版
 */
export const PHOTO_EXPIRED_MONTH_NEW = 6;
/**
 * 写真のダウンロード期限月数 改訂日 ()
 */
export const PHOTO_EXPIRED_MONTH_UPDATED_DATE = '2025-03-31';

/**
 * PhotoAppProps
 */
export type PhotoAppProps = {
  /** 写真ID */
  photoId: PhotoId,
}

/**
 * PhotoAppEntity
 */
export class PhotoAppEntity extends EntityPvt<
  PhotoAppProps,
  PhotoAppJson
> {
  toJsonData(): PhotoAppJson {
    return {
      photoId: this.photoId.value,
    };
  }

  /**
   * Entity名
   */
  get entityName(): EntityNamePvt {
    const name: EntityNamePvt = EntityNamePvt.WagakoNurseryPhotoPhotoAppEntity;
    return name;
  }

  /**
   * Entityキー
   */
  get entityKey(): string {
    return this.photoId.value;
  }

  /**
   * 写真ID
   */
  get photoId(): PhotoId {
    return this._value.photoId;
  }

  /**
   * 写真ID
   */
  set photoId(photoId: PhotoId) {
    this._value.photoId = photoId;
  }

  /**
   * S3フォルダパス
   */
  get s3FolderPath(): string {
    const entityName = EntityName.WagakoNurseryPhotoPhotoEntity;
    return `${entityName}/${this.photoId}/`;
  }

  /**
   * サムネイルS3パス取得
   * @returns サムネイル
   */
  getS3PathThumbnail() {
    return `${this.s3FolderPath}thumbnail.webp`;
  }

  /**
   * サンプルS3パス取得
   * @returns サンプル
   */
  getS3PathSample() {
    return `${this.s3FolderPath}sample.webp`;
  }
}
